import { v4 as uuidv4 } from 'uuid';
import { supabase } from '@/integrations/supabase/client';
import { Message, FileObject } from '@/types';
import { toast } from '@/hooks/use-toast';

export const formatMessages = (messagesData: any[], filesData: any[] = []): Message[] => {
  return messagesData?.map(msg => {
    const fileData = filesData.find(file => file.id === msg.file_id);
    
    let validRole: "user" | "assistant" = "user";
    if (msg.role === "assistant") {
      validRole = msg.role;
    }
    
    const formattedMessage: Message = {
      id: msg.id,
      conversation_id: msg.conversation_id,
      role: validRole,
      content: msg.content,
      created_at: msg.created_at,
      edited: msg.edited || false,
      edited_at: msg.edited_at || undefined,
      // ⚖️ CORREÇÃO CIRÚRGICA: Incluir metadata para ABNT persistente
      metadata: msg.metadata || {},
      file: fileData ? {
        id: fileData.id,
        conversation_id: fileData.conversation_id,
        message_id: fileData.message_id,
        name: fileData.name,
        type: fileData.type,
        size: fileData.size,
        url: fileData.url,
        processed: fileData.processed,
        extracted_text: fileData.extracted_text,
        created_at: fileData.created_at
      } as FileObject : null
    };
    return formattedMessage;
  }) || [];
};

export const callRpc = async <T,>(functionName: string, params: Record<string, any>, userId?: string): Promise<T | null> => {
  try {
    console.log(`Calling RPC: ${functionName}`, params);
    
    if (!userId) {
      console.error(`Cannot call ${functionName}: User not authenticated`);
      throw new Error("User not authenticated");
    }
    
    const { data, error } = await supabase.rpc(functionName as any, params);
    
    if (error) {
      console.error(`Error calling ${functionName}:`, error);
      throw error;
    }
    
    console.log(`RPC ${functionName} result:`, data);
    return data as T;
  } catch (error) {
    console.error(`Exception in ${functionName}:`, error);
    toast({
      title: "Erro",
      description: `Falha ao executar ${functionName}. Por favor, tente novamente.`,
      variant: "destructive",
    });
    return null;
  }
};

export const generateConversationTitle = (content: string, file: File | null = null): string => {
  // If it's a file upload with no content, use the filename
  if (file && !content.trim()) {
    return `Análise de ${file.name}`;
  }
  // For text content, truncate if too long
  else if (content.length > 40) {
    return content.substring(0, 40) + "...";
  }
  return content;
};
